import { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";
import { HGenerateFileData } from "@rf-l1/file/helpers/create-file-data";

const preparePicturesToClient = (res: IPropertyDetailsResponse) => {
  return res?.pictures
    ?.map(item =>
      HGenerateFileData({
        file: item.pictures,
        id: item.id,
        comment: item.comment ?? ""
      })
    )
    .filter(x => x != null);
};

export default preparePicturesToClient;
